import { SharedState } from '@features/_shared/store/state';

export enum Slices {
    Shared = 'shared',
}

export interface RootState {
    [Slices.Shared]: SharedState;
}
